import apiClient from "./client";
import type {
  CreateDisasterManualTriggerPayload,
  DisasterManualTriggerMutationResponse,
} from "../types/disaster";

export const createDisasterManualTrigger = async (
  payload: CreateDisasterManualTriggerPayload
): Promise<DisasterManualTriggerMutationResponse> => {
  const { data } = await apiClient.post<DisasterManualTriggerMutationResponse>(
    "/disaster-manual-trigger",
    payload
  );
  return data;
};
